/**
 * @generated SignedSource<<b9e1a5bbb3221fb41cec96c4ce649ffd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type factSheetSettingsPage_MeQuery$variables = Record<PropertyKey, never>;
export type factSheetSettingsPage_MeQuery$data = {
  readonly me: {
    readonly factSheet: ReadonlyArray<{
      readonly benchmark: number | null | undefined;
      readonly benchmarkLabel: string | null | undefined;
      readonly key: string;
      readonly label: string;
      readonly unit: string;
      readonly value: number | null | undefined;
      readonly visible: boolean;
    }>;
    readonly publicSlug: string | null | undefined;
  } | null | undefined;
};
export type factSheetSettingsPage_MeQuery = {
  response: factSheetSettingsPage_MeQuery$data;
  variables: factSheetSettingsPage_MeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publicSlug",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unit",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "benchmark",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "benchmarkLabel",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visible",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "factSheetSettingsPage_MeQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "FactSheetMetric",
            "kind": "LinkedField",
            "name": "factSheet",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "factSheetSettingsPage_MeQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "FactSheetMetric",
            "kind": "LinkedField",
            "name": "factSheet",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/)
            ],
            "storageKey": null
          },
          (v8/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c16a8e9232058a81ec763866b532b011",
    "id": null,
    "metadata": {},
    "name": "factSheetSettingsPage_MeQuery",
    "operationKind": "query",
    "text": "query factSheetSettingsPage_MeQuery {\n  me {\n    publicSlug\n    factSheet {\n      key\n      label\n      value\n      unit\n      benchmark\n      benchmarkLabel\n      visible\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "3d716ae7a966e18a81ecf300028b4d88";

export default node;
